import * as React from "react";
const SvgMenuIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 3.955h18v2.5H3zM3 10.777h18v2.428H3zM3 17.58h18v2.465H3z" }));
export default SvgMenuIcon;
